module.exports = __webpack_public_path__ + "static/media/provider-photo-behavioral.62c6c53d.jpg";